// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addressHeaderWrapper_2QJp-{display:flex;justify-content:space-between;font-size:larger;font-weight:700}.addressHeaderWrapper_2QJp- .lnk_dSzP3{color:#7123d9;cursor:pointer;text-transform:uppercase}.addressButtons_3lmvf{margin-top:15px}.formSave_2vpJ5{margin-bottom:15px}.nsAddressForm_FmMN7 .dateField_2MNgT{max-width:120px}.nsAddressForm_FmMN7 h2{display:flex;justify-content:space-between;margin-bottom:15px}.hideElement_3haDu{height:0;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"addressHeaderWrapper": "addressHeaderWrapper_2QJp-",
	"lnk": "lnk_dSzP3",
	"addressButtons": "addressButtons_3lmvf",
	"formSave": "formSave_2vpJ5",
	"nsAddressForm": "nsAddressForm_FmMN7",
	"dateField": "dateField_2MNgT",
	"hideElement": "hideElement_3haDu"
};
module.exports = exports;
